import { html } from '../../../../lib/html'
import { renderStillingkort } from '../../../common/stillingskort/stillingkort.html'
import styles from './sokeresultat.module.css'
import { toSlug } from '../../../../lib/emneknagg'

export function renderSokeresultat(sok, emneknagger, baseUrl) {
  if (sok.stillinger?.length) {
    return html`<dh-sexguiden-sokeresultat class="${styles.sokeresultat}" id="resultater">
      ${renderBeskrivelse(sok, emneknagger)}
      <ul>
        ${sok.stillinger.map(
          (stilling, index) =>
            html`<li>${renderStillingkort(stilling, index, sok, baseUrl, index > 2)}</li>`
        )}
      </ul>
    </dh-sexguiden-sokeresultat>`
  } else {
    return html`<div class="${styles.sokeresultat}">
      ${renderBeskrivelse(sok, emneknagger)}
      <h2>Oops!</h2>
      <p>
        Vi klarte ikke å tilfredstille dine behov denne gangen. Det ser ut som du må fjerne noen
        emneknagger for å få treff.
      </p>
    </div>`
  }
}

export function renderHenter(sok) {
  return html`<div class="${styles.sokeresultat}">
    ${renderBeskrivelse(sok)}
    <div class="${styles.henter}">
      <div>Henter stillinger...</div>
    </div>
  </div>`
}

function createResultatbeskrivelse(sok) {
  if (sok.valgteEmneknagger.length) {
    const navn = sok.emneknagger
      .filter((emneknagg) => sok.valgteEmneknagger.includes(toSlug(emneknagg)))
      .map((emneknagg) => emneknagg.navn.toLowerCase())

    if (navn.length > 1) {
      return `Kategorier: ${navn.join(', ')}`
    } else {
      return `Kategori: ${navn.join(', ')}`
    }
  } else {
    return 'Alle stillinger'
  }
}

function createAntallText(sok) {
  if (!sok.stillinger) {
    return 'Laster...'
  } else if (sok.stillinger.length === 1) {
    return `<span class="nrk-sr">Viser</span> 1 stilling`
  } else {
    return `<span class="nrk-sr">Viser</span> ${sok.stillinger.length} stillinger`
  }
}

export function renderBeskrivelse(sok) {
  return html`<div class="${styles.beskrivelse}">
    <h2>${createResultatbeskrivelse(sok)}</h2>
    <div class="${styles.antall}" aria-live="assertive">
      <span role="text"> ${createAntallText(sok)} </span>
    </div>
  </div>`
}
